import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
import { BlockCreateRequest, BlockListReply, BlockReply, BlockUpdateRequest, CreateFromBlockReply, CreateFromBlockRequest, ListWithChildrenReply } from "@/backend/express/controllers/blockController";

export class BlockController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async createBlock(req: BlockCreateRequest): Promise<BlockReply> {
    return this.client.create('/api/blocks', req);
  }

  public async deleteBlock(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/blocks/${id}`);
  }

  public async updateBlock(req: BlockUpdateRequest): Promise<BlockReply> {
    return this.client.update('/api/blocks', req);
  }

  public async readBlock(id: string): Promise<BlockReply> {
    return this.client.read(`/api/blocks/${id}`);
  }

  public async listBlocks(): Promise<BlockListReply> {
    return this.client.read('/api/blocks');
  }

  public async duplicateBlock(id: string): Promise<BlockReply> {
    return this.client.create(`/api/blocks/duplicate/${id}`, {});
  }

  public async listBlocksWithChildren(): Promise<ListWithChildrenReply> {
    return this.client.read('/api/blocks/withChildren');
  }

  public async createFromBlock(req: CreateFromBlockRequest): Promise<CreateFromBlockReply> {
    return this.client.create('/api/blocks/fromBlock', req);
  }
}
